// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: 'AIzaSyAzXG3LlstpFnj1TuPVhx7nEcmbM7r8ego',
  authDomain: 'diet-prod-a6364.firebaseapp.com',
  projectId: 'diet-prod-a6364',
  storageBucket: 'diet-prod-a6364.firebasestorage.app',
  messagingSenderId: '843099099815',
  appId: '1:843099099815:web:90bfda4575eed1eee00182',
  measurementId: 'G-5KBQ1EX232',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
